import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
import { saveCurrent, PILLAR_LABELS } from "@/lib/instant";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EASE = [0.22, 1, 0.36, 1];

const FALLBACK = [
  { name: "J'ai besoin de me calmer", pillar: "respirer" },
  { name: "J'ai besoin de respirer", pillar: "respirer" },
  { name: "J'ai besoin de me recentrer", pillar: "ressentir" },
  { name: "J'ai besoin de relâcher mon corps", pillar: "toucher" },
  { name: "J'ai besoin d'énergie", pillar: "bouger" },
  { name: "Je veux préparer mon sommeil", pillar: "respirer" },
];

export default function Sos() {
  const navigate = useNavigate();
  const [situations, setSituations] = useState(FALLBACK);

  useEffect(() => {
    // Inscription obligatoire : le SOS enregistre le besoin sur la fiche patient
    if (!localStorage.getItem("rav-token")) {
      navigate("/connexion");
      return;
    }
    axios
      .get(`${API}/sos`)
      .then(({ data }) => {
        if (data.situations?.length) setSituations(data.situations);
      })
      .catch(() => {});
  }, []);

  const quick = async (situation) => {
    const token = localStorage.getItem("rav-token");
    axios
      .post(`${API}/sos/use`, { sos_name: situation.name, pillar: situation.pillar }, token ? { headers: { Authorization: `Bearer ${token}` } } : {})
      .catch(() => {});
    if (situation.sound_path) {
      // SOS : UNIQUEMENT l'audio dédié de Julie pour ce thème, lancé directement —
      // on ne pioche rien dans la médiathèque générale (contrairement aux Instants).
      saveCurrent({
        pillar: situation.pillar || "respirer",
        minutes: 5,
        steps: [
          {
            pillar: situation.pillar || "respirer",
            label: PILLAR_LABELS[situation.pillar] || "SOS",
            minutes: 5,
            title: situation.name,
            description: "Cinq minutes rien que pour vous.",
            kind: "sos",
            media_path: null,
            sound: situation.sound_path,
          },
        ],
      });
      navigate("/session");
      return;
    }
    try {
      // Repli si un thème n'a pas encore son audio dédié
      const { data } = await axios.post(`${API}/instants/compose`, { pillar: situation.pillar, minutes: 5 });
      saveCurrent(data);
      navigate("/session");
    } catch {
      navigate("/");
    }
  };

  return (
    <main className="rav-page" data-testid="sos-page">
      <motion.img
        src="/logo-accueil.webp"
        alt="Respire Aime Vibre"
        className="rav-page-logo"
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, ease: EASE }}
      />
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.1, ease: EASE }}>
        <h1 className="rav-page-title" data-testid="sos-title">SOS — 5 minutes</h1>
        <p className="rav-page-sub">Un besoin immédiat ? On fait simple.</p>
        <div className="rav-sos-list">
          {situations.map((q, i) => (
            <motion.button
              key={q.id || q.name}
              type="button"
              className="rav-sos-item"
              data-testid={`sos-${i}`}
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2 + i * 0.08, ease: EASE }}
              onClick={() => quick(q)}
            >
              {q.name}
            </motion.button>
          ))}
        </div>
        <button type="button" className="rav-text-link" data-testid="sos-back" onClick={() => navigate("/")}>
          Retour à l'accueil
        </button>
      </motion.div>
    </main>
  );
}
